import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";
import { StateToObj } from "./reduxHelper";

const initialState = {
    "id" : uuidv4(),
    "data": ""
}
const chatSeenPendingMsg = createSlice({
    name:'chatSeenPendingMsg',
    initialState,
    reducers:{
        addchatSeenPendingMsg: (_state,payload)=>{
            return {
            ..._state,
            "id" : uuidv4(),
            "data": [
                ...StateToObj(_state).data,
                payload.payload]
            }
        },
        removechatSeenPendingMsg: (_state,payload)=>{
            return initialState
        },
    }
});

export default chatSeenPendingMsg.reducer
export const addchatSeenPendingMsg = chatSeenPendingMsg.actions.addchatSeenPendingMsg
export const removechatSeenPendingMsg = chatSeenPendingMsg.actions.removechatSeenPendingMsg